<template lang="pug">
app-page-layout(fix-header)
  div.pl2.pt3.px3
    a-button.mr2( v-for="(cate, index) in categorys" 
      :key="index"
      :class="{active: filters.status === cate.code }"
      @click="filters.status = cate.code"
    ) {{ cate.name }} {{ statistics[cate.code] }}

  app-table-page-layout
    template(#toolbar-left)
      //- app-input-search(@search='handleQuickSearch')
      app-search(
        v-model="filters"
        :fields="filterFieleds"
        @search="handleQuickSearch"
        keywordPlaceholder="请输入关键字"
      )
      a-button.ml2(@click='$refs.table.reload()') 刷新
    template(#toolbar-right)
      app-link-btn(to="vendors-orders/create")
        a-button(type="primary" icon="plus") 新建
      //- a-button(type="primary" icon="plus" @click="handleCreate") 新建
      //- a-button.ml2(type="primary" :loading="exportLoading" @click="handleExport") 导出数据
      //- a-button.ml2(
      //-   type="danger"
      //-   @click="handleDeleteBatch"
      //-   :disabled="!canDeleteBatch"
      //-   :loading="deleteBatchLoading"
      //- ) 批量删除
    app-table(
      ref="table"
      model-name="orders"
      url="/prj/orders/vendor/page"
      :params="params"
      :visibles="columns"
      :columns-customsize="columnsCustomsize"
      :fitHeight="-20"
      @select="handleSelectChange",
      @selectChange="handleSelectChange",
      @change="handleSelectChange",
      @loaded="(select) => {handleSelectChange(select); loadStat();}"
    )
      //- :fitHeight="-40" 
      template(#code="{text, record}")
        app-link-btn(:to="'./orders/' + record.id") {{ text }}
      template(#action="{record}")
        app-action-column
          //- app-link-btn-confirm(
          //-   v-if="!record.enabled"
          //-   @confirm="(cb) => handleEnable(record, cb, true)"
          //-   title="是否启用？"
          //- ) 启用
          //- app-link-btn-confirm(
          //-   v-else
          //-   @confirm="(cb) => handleEnable(record, cb, false)"
          //-   title="是否停用？"
          //- ) 停用
          //- app-link-btn(@click="handleEdit(record)") 编辑
          app-link-btn(:disabled="!['orderStatus_submitting','orderStatus_reject'].includes(record.status)" :to="'vendors-orders/edit/' + record.id") 编辑
          //- app-link-btn-delete(@confirm="(cb) => handleDelete(record, cb)") 删除
    CreateAndEdit(ref="createAndEdit" @modal-success="$refs.table.reload()")
</template>

<script>
import { GETTER_PROJECT } from '@store/account';
import { GETTER_DICT_TREE_MAP } from '@store/dict';
import { mapGetters } from 'vuex';
import CreateAndEdit from './Modal/CreateAndEdit';
import moment from 'moment';
export default {
  name: 'KeepAliveXxxx',
  components: {
    CreateAndEdit,
  },
  data() {
    return {
      columns: [
        'code',
        'vendorId',
        'customerName',
        'appointmentTime',
        'submitTime',
        'feeMode',
        'amount',
        'serviceFee',
        'pickupAddress',
        'customerMobile',
        'stockType',
        'stockSubType',
        // 'customerAddress',
        // 'stockType',
        // 'stockSubType',
        // 'stockTime',
        // 'vendorComments',
        // 'takerComments',
        // 'keeperComments',
        // 'schedulerComments',
        // 'dutyPostId',
        // 'dutyUserId',
        // 'carArranged',
        'status',
        // 'createBy',
        // 'createTime',
        // 'updateBy',
        // 'updateTime',
      ],
      search: null,
      // 批量删除
      canDeleteBatch: false,
      deleteBatchLoading: false,
      // 筛选
      filters: {
        status: 'orderStatus_submitting',
      },
      filterFieleds: [],
      // 导出
      exportLoading: false,
      // 统计
      statistics: {},
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      dictTreeMap: GETTER_DICT_TREE_MAP,
    }),
    params() {
      return {
        // search: this.search,
        ...this.filters,
        projectId: this.project.id,
      };
    },
    categorys() {
      const categorys = this.dictTreeMap['orderStatus'] || [];
      return categorys.sort((a, b) => a.sort - b.sort);
    },
  },
  created() {
    this.initFilters();

    this.loadStat();
    this.intervalTicket = setInterval(() => {
      this.loadStat();
    }, 60000);
  },
  beforeDestroy() {
    if (this.intervalTicket) {
      clearInterval(this.intervalTicket);
      this.intervalTicket = null;
    }
  },
  methods: {
    loadStat() {
      this.$restful('GET:/prj/orders/vendor/statistics', {
        projectId: this.project.id,
      }).then((res) => {
        this.statistics = res;
      });
    },
    // getVendorList() {
    //   this.$restful(`GET:/prj/vendor-user-mappings/list`, {
    //     projectId: this.project.id,
    //   }).then((res) => {
    //     this.vendorList = (res || []).map((item) => item.vendorDTO);
    //     this.vendor = this.vendorList[0];
    //   });
    // },
    reload() {
      this.$refs.table.reload();
    },
    handleQuickSearch(keyword) {
      this.search = keyword;
    },
    // 新增
    handleCreate() {
      this.$refs.createAndEdit.show();
    },
    // 修改
    handleEdit(record) {
      this.$refs.createAndEdit.show(record);
    },
    columnsCustomsize(columns, config) {
      columns.push({
        uid: 'action',
        dataIndex: 'action',
        title: '操作',
        width: '8rem',
        fixed: config.fixedActionColumn ? 'right' : null,
      });
      return columns;
    },
    // 启用/禁用
    async handleEnable(record, cb, enabled) {
      //inspplans
      await this.$restful(
        `PUT:/prj/orders/${record.id}/enables`,
        { enabled },
        { params: { enabled } },
      );
      cb();
      this.$message.success('操作成功!');
      this.$refs.table.reload();
    },
    // 删除
    async handleDelete(record, cb) {
      await this.$restful(`DELETE:/prj/orders/${record.id}`);
      cb();
      this.$message.success('删除成功!');
      this.$refs.table.reload();
    },
    // 批量删除
    handleDeleteBatch() {
      this.deleteBatchLoading = true;
      const ids = this.$refs.table.getSelection()?.map((item) => item.id);
      this.$restful(`DELETE:/prj/orders`, {
        ids: ids,
      })
        .then(() => {
          this.$refs.table.reload();
        })
        .finally(() => {
          this.deleteBatchLoading = false;
        });
    },
    // 是否可以批量删除
    handleSelectChange(select) {
      // console.log(select?.selectedRowKeys);
      if (select?.selectedRowKeys?.length) {
        this.canDeleteBatch = true;
      } else {
        this.canDeleteBatch = false;
      }
    },
    // 导出数据
    moment,
    handleExport() {
      this.exportLoading = true;
      this.$restful(
        `GET:/prj/orders/data-export`,
        { ...this.params },
        { responseType: 'blob' },
      )
        .then((res) => {
          const link = document.createElement('a');
          let blob = new Blob([res], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            'download',
            '订单数据导出' + this.moment().format('YYYYMMDDHHmmss') + '.xlsx',
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [
        // {
        //   name: 'status',
        //   component: 'app-remote-select',
        //   width: '150px',
        //   placeholder: '订单状态',
        //   api: '/sys/dict-datas/graph?typeCode=orderStatus',
        //   field: { name: 'code', label: 'name' },
        // },
      ];
    },
  },
};
</script>
<style lang="less" scoped>
// .
</style>
